
import parallax from 'jarallax/dist/jarallax.js';


jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.85
});

// jarallax(document.querySelectorAll('.jarallax'), 'destroy');